import styled from 'styled-components'

import { CardsWithTab as CardsWithTabBase } from '@application/Interfaces/Features/CardsWithTab'
import { CBMCalculator as CBMCalculatorBase } from '@application/Interfaces/Features/CBMCalculator'
import { TitleDescriptionAccordion as TitleDescriptionAccordionBase } from '@application/Interfaces/Features/TitleDescriptionAccordion'
import Container from '@mui/material/Container'

export const Wrapper = styled(Container)`
    padding: 50px 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 150px 0px;
    }
`
export const TitleDescriptionAccordion = styled(TitleDescriptionAccordionBase)`
    margin: 16px 0px;
`

export const CardsWithTab = styled(CardsWithTabBase)`
    margin: 16px 0px;
`

export const Content = styled.div`
    width: 100%;

    ${(props) => props.theme.typo.bodyL}
    color: ${(props) => props.theme.color.g600};

    h1 {
        ${(props) => props.theme.typo.displayXL}
    }

    h2 {
        ${(props) => props.theme.typo.displayL}
        color: ${(props) => props.theme.color.p500};
    }

    h3 {
        ${(props) => props.theme.typo.displayM}
        color: ${(props) => props.theme.color.p500};
    }

    h4 {
        ${(props) => props.theme.typo.bodyL}
    }

    h5 {
        ${(props) => props.theme.typo.bodyM}
    }

    h6 {
        ${(props) => props.theme.typo.bodyS}
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        ${(props) => props.theme.fontWeight.bold}
        display: inline-block;
        margin-top: 24px;
        margin-bottom: 16px;
    }
`

export const CBMCalculator = styled(CBMCalculatorBase)`
    background-color: transparent;
    padding: 15px 0;

    .MuiContainer-root {
        padding: 0;
    }
`
